<template>
        <app-page-content>
            <app-dashboard-filters 
                :start-date="filters.startDate"
                :end-date="filters.endDate"
                :handle-start-date-change="handleStartDateChange"
                :handle-end-date-change="handleEndDateChange"
                :onFilter="loadData"
            />
            <div class="print-header-container d-none d-print-block">
                <div class="print-header jumbotron1 d-flex flex-column align-items-start">
                    <div class="report-logo d-flex justify-content-center w-100">
                        <img src="images/bitacorapp-logo.png" alt="">
                    </div>
                    <div class="w-50 mt-5 mb-5">
                        <table>
                            <tr>
                                <td><app-sub-title text="Cliente:" /></td>
                                <td class="pl-3"><strong>{{ selectedClient.name }}</strong></td>
                            </tr>
                            <tr>
                                <td><app-sub-title text="Periodo del reporte:" /></td>
                                <td class="pl-3"><strong>{{ filters.startDate | date }} - {{ filters.endDate | date }}</strong></td>
                            </tr>
                            <tr>
                                <td><app-sub-title text="Impreso el:" /></td>
                                <td class="pl-3"><strong>{{ moment().format('DD/MM/YYYY HH:mm:ss') }}</strong></td>
                            </tr>
                            <tr>
                                <td><app-sub-title text="Impreso por:" /></td>
                                <td class="pl-3"><strong>{{ user.name }}</strong></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <b-row>
                <b-col cols="12" md="6">
                    <b-card>
                        <app-pie-chart 
                            title="1. Ingresos Peatonales por Tipo"
                            :chart-data="personEntriesData"
                        />
                    </b-card>
                </b-col>
                <b-col cols="12" md="6">
                    <b-card>
                        <app-pie-chart 
                            title="2. Ingresos Vehiculares por Tipo"
                            :chart-data="vehicleEntriesData"
                        />
                    </b-card>
                </b-col>
                <b-col cols="12" md="6">
                    <b-card>
                        <app-pie-chart 
                            title="3. Top 10 Estructuras más visitadas"
                            :chart-data="top10StructuresByVisitors"
                        />
                    </b-card>
                </b-col>
                <b-col cols="12" md="6">
                    <b-card>
                        <app-column-chart 
                            title="4. Histórico Visitas Peatonales (12 meses)"
                            :chart-data="historicalEntries"
                        />
                    </b-card>
                </b-col>
                <div class="w-100 pagebreak"></div>
                <b-col cols="12" md="6">
                    <b-card>
                        <app-column-chart 
                            title="6. Histórico Visitas Vehiculares(12 meses)"
                            :chart-data="historicalVehicleEntries"
                        />
                    </b-card>
                </b-col>
                <b-col cols="12" md="6">
                    <b-card>
                        <app-pie-chart 
                            title="6. Correspondencia Recibida por Tipo"
                            :chart-data="mailsData"
                        />
                    </b-card>
                </b-col>
                <b-col cols="12" md="6">
                    <b-card>
                        <app-pie-chart 
                            title="7. Correspondencia Entregada"
                            :chart-data="deliveredMailsData"
                        />
                    </b-card>
                </b-col>
                <b-col cols="12" md="6">
                    <b-card>
                        <app-pie-chart 
                            title="8. Anotaciónes"
                            :chart-data="notebookData"
                        />
                    </b-card>
                </b-col>
                <b-col cols="12" md="6">
                    <b-card>
                        <app-pie-chart 
                            title="9. PQR's"
                            :chart-data="pqrIndicatorData"
                        />
                    </b-card>
                </b-col>
            </b-row>
        </app-page-content>
    </template>
    <script>
    
    import ChartContainer from '../../../Charts/ChartContainer.vue';
    import DashboardFilters from '../DashboardFilters/DashboardFilters.vue';
    import reportingRepository from '../../../../../repositories/reporting.repository';
    import PieChart from '../../../Charts/PieChart.vue';
    import ColumnChart from '../../../Charts/ColumnChart.vue';
    import { reportDataProcess } from "../../../../../mixin";
    export default {
        components: {
            appChartContainer: ChartContainer,
            appDashboardFilters: DashboardFilters,
            appPieChart: PieChart,
            appColumnChart: ColumnChart
        },
        mixins: [reportDataProcess],
        props: {
            selectedClient: {
                type: Object
            }
        },
        data(){
            return {
                filters: {
                    startDate: '',
                    endDate: ''
                },
                personEntriesData: [],
                vehicleEntriesData: [],
                mailsData: [],
                deliveredMailsData: [],
                top10StructuresByVisitors: [],
                historicalEntries: [],
                historicalVehicleEntries: [],
                internalManagement: [],
                notebookData: [],
                pqrIndicatorData: []
            }
        },
        watch: {
            selectedClient(){
                this.loadData();
            }
        },
        methods: {
            handleStartDateChange(date){
                // this.filters.startDate = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                this.filters.startDate = moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
            },
            handleEndDateChange(date){
                // this.filters.endDate = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                this.filters.endDate = moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
            },
            async loadData(){
                try {
                    const rr = {...reportingRepository};
                    const filters = {
                        client: this.selectedClient.id,
                        startDate: !!this.filters.startDate? this.filters.startDate: '',
                        endDate: !!this.filters.endDate? this.filters.endDate: ''
                    }
        
                    const {data} = await rr.getClientDashboard(filters);

                    this.personEntriesData = this.processPersonEntryData(data.personEntries);
                    this.vehicleEntriesData = this.processVehicleEntryData(data.vehicleEntries);
                    this.mailsData = this.processMailData(data.mails);
                    this.deliveredMailsData = this.processDeliveredMailsData(data.deliveredMails);
                    this.top10StructuresByVisitors = this.processTop10StructuresByVisitors(data.top10StructuresByVisitors);
                    this.historicalEntries = this.processHistoricalEntries(data.historicalEntries);
                    this.historicalVehicleEntries = this.processHistoricalEntries(data.historicalVehicleEntries);
                    this.internalManagement = data.internalManagement;
                    this.notebookData = this.processNotebookData(data.notebook);
                    this.pqrIndicatorData = this.processPqrIndicatorData(data.pqrIndicator);
                }catch(err) {
                    toastr.error(`Ocurrió un error cargando los datos [${err.message}]`);
                }
                
            },
            setDefaultDates(){
                const startDate = moment().startOf('month').format('YYYY-MM-DD');
                const endDate = moment().endOf('month').format('YYYY-MM-DD');
                this.filters.startDate = startDate;
                this.filters.endDate = endDate;
            },
            initializeDashboard(){
                this.setDefaultDates();
                this.loadData();
            }
        },
        created(){
            this.initializeDashboard();
        }
    }
    </script>
    <style scoped>
        .charts {
            display: flex;
        }
        .pagebreak{
            page-break-before: always;
        }
    </style>